/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_No_ResponseInputs */

const es_feedback_modal_no_response = /** @type {(inputs: Feedback_Modal_No_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay una respuesta asociada a este feedback.`)
};

const en_feedback_modal_no_response = /** @type {(inputs: Feedback_Modal_No_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no response associated with this feedback yet.`)
};

/**
* | output |
* | --- |
* | "There is no response associated with this feedback yet." |
*
* @param {Feedback_Modal_No_ResponseInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_no_response = /** @type {((inputs?: Feedback_Modal_No_ResponseInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_No_ResponseInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_no_response(inputs)
	return en_feedback_modal_no_response(inputs)
});
export { feedback_modal_no_response as "feedback.modal.no_response" }